<template lang="pug">
  model-form(
    ref="form"
    submit-text="Guardar"
    title="Mutual Seguridad"
    v-bind="formProps"
    v-model="formData"
    @reset="reset"
    @submit="submit"
    :switchEdit="$can('EDIT_COMPANY_MUTUAL_DATA')"
  )
</template>

<script>
import { ModelForm } from '@/components/reusable_components/next/'
import fields from './fields'
/* model */
import HrMutual from '@/models/HumanResource/HrMutual'
/* vuex */
import { mapActions } from 'vuex'
import Translator from '@/services/translator'
export default {
    name: 'mutual-form',
    // props: {},
    data: function() {
        return {
            formData: {},
        }
    },
    computed: {
        formProps() {
            return {
                editable: this.$can('EDIT_COMPANY_MUTUAL_DATA'),
                fields,
            }
        },
    },
    methods: {
        // -- UI Modification
        // -- Data fetching
        /*
         */
        create(model) {
            model
                .clean([])
                .sync(model.toCreate())
                .then(this.showSuccess)
                .catch(this.showError)
                .then(this.$refs.form.setWait)
        },
        // -- Data handling and transformations

        // -- Validations and Error handling
        // -- Other functions
        reset() {
            HrMutual.find(1).then(resp => {
                this.formData = resp
            })
        },
        /*
         */
        showError(error) {
            this.showSnackbar(
                'error',
                'Error.',
                Translator(HrMutual, error.response.data)
            )
        },

        /**
         *
         */
        showSnackbar(type, title, message, callback) {
            this.initSnackbar(this.fillSnack(type, title, message))
            if (typeof callback === 'function') callback()
        },

        /**
         *
         */
        showSuccess() {
            this.showSnackbar(
                'success',
                'Éxito.',
                'Mutual Registrada exitosamente.'
                //this.redirect
            )
            this.$refs.form.edit = false
        },

        /**
         *
         */
        submit() {
            this.$refs.form.setWait(true).then(this.create)
        },
        // -- Vuex mappings
        /*
         */
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
    },
    // watch: {},
    components: {
        'model-form': ModelForm,
    },
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    beforeMount() {
        this.setTitleTopBar('Mutual')
    },
    mounted() {
        this.reset()
        this.$refs.form.edit = false
        this.setAppToolbarTitle('Mutual')
    },
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
</style>